import { _doPermissionsCheck } from '$lib/localNotifications/doPermissionCheck';
import { _migrateNotifications } from '$lib/localNotifications/migrateNotifications';
import { _scheduleRecurringNotification } from '$lib/localNotifications/scheduleRecurringNotification';

export const localNotifications = {
	doPermissionsCheck: _doPermissionsCheck,
	scheduleRecurringNotification: _scheduleRecurringNotification,
	migrateNotifications: _migrateNotifications,
};
